import React, { useEffect } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import moment from "moment";
import history from "../../history";
import CartTitle from "../CartTitle";
import { fetchQueryParams } from "../../utils/comman";
import CustomButton from "../CustomButton";
import Loader from "../Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DesignCard from "../DesignCard";

import get from "lodash/get";

const _ = { get };

function onBoardedUserDetail(props) {
  let { elements } = props;
  useEffect(() => {
    let queryParams = props.query;
    if (queryParams === "") {
      history.push(`/user/onboard-users-list`);
    } else {
      const params = fetchQueryParams(props.query);
      props.handleFetchOnBoardUserDetailList(params.userId);
    }
  }, []);

  const handleToVehicles = () => {
    if (props.singleUser !== null) {
      history.push(
        `/user/vechile-onboarding?guid=${props.singleUser.guid}&id=${props.singleUser._id}`
      );
    }
  };
  return (
    <React.Fragment>
      {props.onBoardedUserDetailStatus !== false ? <Loader /> : null}
      <div className="hideSearch">
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "userDetailsElements.headingElement",
                "User Detail"
              )}
              iconClass={"hideexcel"}
              Name={"Filter"}
              customClass={"hidebtn"}
              innerTextClass={"hidetext"}
            />
          </Col>
        </Row>

        <Card className="mb-3">
          {props.singleUser ? (
            <CardBody>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "userDetailsElements.subHeadingElement",
                        "PERSONAL INFORMATION"
                      )}
                    </span>
                  </h2>
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.fNameLabel",
                      "First Name"
                    )}
                    titleName={props.singleUser.fName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.lNameLabel",
                      "Last Name"
                    )}
                    titleName={props.singleUser.lName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.emailLabel",
                      "Email ID"
                    )}
                    titleName={props.singleUser.contactDetails.email}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.mobileNumber",
                      "Phone Number"
                    )}
                    titleName={
                      props.singleUser.contactDetails.mobile.primary.number
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.countryCodeLabel",
                      "Country Code"
                    )}
                    titleName={props.singleUser.locality.country}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.genderLabel",
                      "Gender"
                    )}
                    titleName={props.singleUser.gender}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.dobLabel",
                      "DOB"
                    )}
                    titleName={moment(props.singleUser.dob).format(
                      "DD/MM/YYYY"
                    )}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.clusterLabel",
                      "Cluster"
                    )}
                    titleName={props.singleUser.cluster}
                  />
                </Col>
              </Row>
              <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "userDetailsElements.addVehicleElement",
                    "Add Vehicle"
                  )}
                  customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  customClick={
                    props.singleUser.ridersClubMember !== true
                      ? handleToVehicles
                      : () =>
                          toast.error(
                            _.get(
                              elements,
                              "userDetailsElements.alreadyAMemberValidationElement",
                              "Already Member"
                            )
                          )
                  }
                />
              </div>
            </CardBody>
          ) : null}
        </Card>
      </div>
    </React.Fragment>
  );
}

export default onBoardedUserDetail;
